import React, { useCallback, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import ReactTable from '../Utils/ReactTable';
import { useTranslation } from 'react-i18next';

const UsersTable = ({ tableData, setSelectedUser, selectedUser, csvData }) => {
  const data = useMemo(() => tableData, [tableData]);
  const { t } = useTranslation();

  // Convert selectedUser to string if it's a number
  const selectedRowId = selectedUser?.toString();

  const columns = useMemo(
    () => [
      {
        Header: t('username'),
        accessor: 'name',
        Cell: ({ cell }) => {
          return (
            <React.Fragment>
              <span className='color-link' style={{ backgroundColor: cell.row.original.color }}>
                &nbsp;
              </span>
              <span>{cell.row.values.name}</span>
            </React.Fragment>
          );
        }
      },
      {
        Header: t('email'),
        accessor: 'email'
      },
      {
        Header: t('role'),
        accessor: 'role'
      },
      {
        Header: t('sessions'),
        accessor: 'session',
        Cell: ({ cell }) => {
          return cell.row.values.session.length;
        }
      },
      {
        Header: t('parent_org'),
        accessor: 'parent_organization',
        className: 'ellipsis'
      },
      {
        Header: t('total_energy_kwh'),
        accessor: 'energy',
        Cell: ({ cell }) => {
          let totalEnergy = 0;
          cell.row.values.session.forEach((session) => {
            // Use session.totalEnergyConsumed directly (V2 now stores energy on session like V1)
            const sessionEnergy = (session?.totalEnergyConsumed ?? 0) / 1000; // Convert Wh to kWh
            totalEnergy += sessionEnergy;
          });
          // Round to 2 decimal places
          return totalEnergy.toFixed(2);
        }
      }
    ],
    [t]
  );

  return (
    <ReactTable
      data={data}
      csvData={csvData}
      columns={columns}
      selectedRow={selectedRowId}
      setSelectedRow={(value) => setSelectedUser(value ? Number(value) : null)}
      exportCsv
    />
  );
};

UsersTable.propTypes = {
  tableData: PropTypes.array.isRequired,
  selectedUser: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  setSelectedUser: PropTypes.func,
  csvData: PropTypes.array
};

export default UsersTable;
